const { subject } = require("@casl/ability");

const defaultAbility = [
  {
    action: "Lihat",
    subject: "c-dashboard",
  },
  {
    action: "Lihat",
    subject: "monitoring",
  },
  {
    action: "Lihat",
    subject: "validasiKeberadaan",
  },
  {
    action: "Detail",
    subject: "validasiKeberadaan",
  },
  {
    action: "Lihat",
    subject: "dataInformasi",
  },
  {
    action: "Detail",
    subject: "dataInformasi",
  },
  {
    action: "Lihat",
    subject: "validasiBelumTercatat",
  },
  {
    action: "Detail",
    subject: "validasiBelumTercatat",
  },
  {
    action: "Lihat",
    subject: "beritaAcara",
  },
  {
    action: "Lihat",
    subject: "sptjm",
  },
  {
    action: "Lihat",
    subject: "laporan",
  },
  // sensus B
  {
    action: "Lihat",
    subject: "b-dashboard",
  },
  {
    action: "Lihat",
    subject: "b-sk-tim",
  },
  {
    action: "Lihat",
    subject: "b-hasil-sensus",
  },
  {
    action: "Lihat",
    subject: "master",
  },
  {
    action: "Lihat",
    subject: "b-ruangan",
  },
  {
    action: "Lihat",
    subject: "b-monitoring",
  },
  {
    action: "Lihat",
    subject: "b-berita-acara-hasil-inventarisasi",
  },
  {
    action: "Lihat",
    subject: "b-perkin",
  },
  {
    action: "Lihat",
    subject: "b-dokumen-inventarisasi",
  },
];

module.exports = {
  "Super Admin": [
    {
      action: "manage",
      subject: "all",
    },
  ],
  admin: [
    ...defaultAbility,
    {
      action: "Filter",
      subject: "b-dashboard",
    },
    {
      action: "Filter",
      subject: "b-ruangan",
    },
    {
      action: "Filter",
      subject: "b-monitoring",
    },
    {
      action: "Lihat",
      subject: "master",
    },
    {
      action: "Lihat",
      subject: "master-jenis-ruangan",
    },
    {
      action: "Pengembalian-PUA",
      subject: "b-hasil-sensus",
    },
    {
      action: "Lihat",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Cetak-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Download-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
  ],
  internal: [
    ...defaultAbility,
    // C
    {
      action: "Filter",
      subject: "dashboard",
    },
    {
      action: "Filter",
      subject: "monitoring",
    },
    {
      action: "Lihat",
      subject: "perkin",
    },
    {
      action: "Buat",
      subject: "perkin",
    },
    {
      action: "Lihat",
      subject: "cetakBarcode",
    },
    {
      action: "Filter",
      subject: "cetakBarcode",
    },
    {
      action: "Filter",
      subject: "validasiKeberadaan",
    },
    {
      action: "Filter",
      subject: "dataInformasi",
    },
    {
      action: "Lihat",
      subject: "cetakQrCode",
    },
    {
      action: "Filter",
      subject: "cetakQrCode",
    },
    {
      action: "Print",
      subject: "cetakQrCode",
    },
    {
      action: "Filter",
      subject: "validasiBelumTercatat",
    },
    {
      action: "Filter",
      subject: "beritaAcara",
    },
    {
      action: "Filter",
      subject: "sptjm",
    },
    {
      action: "Filter",
      subject: "laporan",
    },
    {
      action: "Lihat",
      subject: "koreksi",
    },
    {
      action: "Lihat",
      subject: "koreksi-pengembalian",
    },
    {
      action: "Buat",
      subject: "koreksi-pengembalian",
    },
    {
      action: "Lihat",
      subject: "koreksi-cleansing",
    },
    {
      action: "Buat",
      subject: "koreksi-cleansing",
    },
    // B
    {
      action: "Filter",
      subject: "b-dashboard",
    },
    {
      action: "Filter",
      subject: "b-ruangan",
    },
    {
      action: "Filter",
      subject: "b-monitoring",
    },
    {
      action: "Lihat",
      subject: "b-daftar-bmd",
    },
    {
      action: "Lihat",
      subject: "b-pendalaman-register",
    },
    {
      action: "Pengembalian-PUA",
      subject: "b-hasil-sensus",
    },
    {
      action: "Lihat",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Cetak-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
  ],
  external: [
    {
      action: "Lihat",
      subject: "validasiKeberadaan",
    },
    {
      action: "Detail",
      subject: "validasiKeberadaan",
    },
    {
      action: "Lihat",
      subject: "dataInformasi",
    },
    {
      action: "Detail",
      subject: "dataInformasi",
    },
    {
      action: "Lihat",
      subject: "validasiBelumTercatat",
    },
    {
      action: "Detail",
      subject: "validasiBelumTercatat",
    },
    {
      action: "Lihat",
      subject: "beritaAcara",
    },
    {
      action: "Lihat",
      subject: "sptjm",
    },
    {
      action: "Lihat",
      subject: "laporan",
    },
    // sensus B
    {
      action: "Lihat",
      subject: "b-sk-tim",
    },
    {
      action: "Lihat",
      subject: "b-hasil-sensus",
    },
    {
      action: "Lihat",
      subject: "master",
    },
    {
      action: "Lihat",
      subject: "b-ruangan",
    },
    // C
    {
      action: "Filter",
      subject: "dashboard",
    },
    {
      action: "Filter",
      subject: "monitoring",
    },
    {
      action: "Lihat",
      subject: "perkin",
    },
    {
      action: "Buat",
      subject: "perkin",
    },
    {
      action: "Lihat",
      subject: "cetakBarcode",
    },
    {
      action: "Filter",
      subject: "cetakBarcode",
    },
    {
      action: "Filter",
      subject: "validasiKeberadaan",
    },
    {
      action: "Filter",
      subject: "dataInformasi",
    },
    {
      action: "Lihat",
      subject: "cetakQrCode",
    },
    {
      action: "Filter",
      subject: "cetakQrCode",
    },
    {
      action: "Print",
      subject: "cetakQrCode",
    },
    {
      action: "Filter",
      subject: "validasiBelumTercatat",
    },
    {
      action: "Filter",
      subject: "beritaAcara",
    },
    {
      action: "Filter",
      subject: "sptjm",
    },
    {
      action: "Filter",
      subject: "laporan",
    },
    {
      action: "Lihat",
      subject: "koreksi",
    },
    {
      action: "Lihat",
      subject: "koreksi-pengembalian",
    },
    {
      action: "Buat",
      subject: "koreksi-pengembalian",
    },
    {
      action: "Lihat",
      subject: "koreksi-cleansing",
    },
    {
      action: "Buat",
      subject: "koreksi-cleansing",
    },
    // B
    {
      action: "Filter",
      subject: "b-dashboard",
    },
    {
      action: "Filter",
      subject: "b-ruangan",
    },
    {
      action: "Filter",
      subject: "b-monitoring",
    },
    {
      action: "Lihat",
      subject: "b-daftar-bmd",
    },
    {
      action: "Pengembalian-PUA",
      subject: "b-hasil-sensus",
    },
    {
      action: "Cetak-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
  ],
  A: [
    ...defaultAbility,
    {
      action: "Lihat",
      subject: "b-dashboard",
    },
    {
      action: "Lihat",
      subject: "b-sk-tim",
    },
    {
      action: "Validasi-Kepala",
      subject: "b-sk-tim",
    },
    {
      action: "Lihat",
      subject: "b-daftar-bmd",
    },
    {
      action: "Validasi-Kepala",
      subject: "b-daftar-bmd",
    },
    {
      action: "Lihat",
      subject: "master",
    },
    {
      action: "Validasi-Kepala",
      subject: "b-hasil-sensus",
    },
    {
      action: "Lihat",
      subject: "b-monitoring",
    },
    {
      action: "Lihat",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Cetak-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Download-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
    
  ],
  D: [
    ...defaultAbility,
    {
      action: "Lihat",
      subject: "cetakDaftarBmd",
    },
    {
      action: "Validasi",
      subject: "validasiKeberadaan",
    },
    {
      action: "Validasi",
      subject: "dataInformasi",
    },
    {
      action: "Validasi",
      subject: "validasiBelumTercatat",
    },
    {
      action: "Lihat",
      subject: "b-dashboard",
    },
    {
      action: "Lihat",
      subject: "b-sk-tim",
    },
    {
      action: "Validasi-P3B",
      subject: "b-sk-tim",
    },
    {
      action: "Lihat",
      subject: "b-daftar-bmd",
    },
    {
      action: "Validasi-P3B",
      subject: "b-daftar-bmd",
    },
    {
      action: "Validasi-P3B",
      subject: "b-hasil-sensus",
    },
    {
      action: "Lihat",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Cetak-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Download-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
  ],
  "pelaksana-suban": [
    ...defaultAbility,
    // C
    {
      action: "Filter-PdUpd",
      subject: "dashboard",
    },
    {
      action: "Filter-PdUpd",
      subject: "monitoring",
    },
    {
      action: "Filter-PdUpd",
      subject: "validasiKeberadaan",
    },
    {
      action: "Filter-PdUpd",
      subject: "dataInformasi",
    },
    {
      action: "Lihat",
      subject: "cetakQrCode",
    },
    {
      action: "Filter-PdUpd",
      subject: "cetakQrCode",
    },
    {
      action: "Filter-PdUpd",
      subject: "validasiBelumTercatat",
    },
    {
      action: "Filter-PdUpd",
      subject: "beritaAcara",
    },
    {
      action: "Filter-PdUpd",
      subject: "sptjm",
    },
    {
      action: "Filter-PdUpd",
      subject: "laporan",
    },
    {
      action: "Lihat",
      subject: "b-dokumen-inventarisasi",
    },
  ],
  F: [
    ...defaultAbility,
    // C
    {
      action: "Lihat",
      subject: "cetakDaftarBmd",
    },
    {
      action: "Buat",
      subject: "dataInformasi",
    },
    {
      action: "Upload",
      subject: "beritaAcara",
    },
    {
      action: "Upload",
      subject: "sptjm",
    },
    // B
    {
      action: "Buat",
      subject: "b-ruangan",
    },
    {
      action: "Ubah",
      subject: "b-ruangan",
    },
    {
      action: "Hapus",
      subject: "b-ruangan",
    },
    {
      action: "Print",
      subject: "b-ruangan",
    },
    {
      action: "Lihat",
      subject: "b-pendalaman-register",
    },
    {
      action: "Update",
      subject: "b-sk-tim",
    },
    {
      action: "Upload-Dokumen",
      subject: "b-sk-tim",
    },
    {
      action: "Lihat",
      subject: "b-daftar-bmd",
    },
    {
      action: "Sumbit-Pengajuan",
      subject: "b-daftar-bmd",
    },
    {
      action: "Buat",
      subject: "b-pendalaman-register",
    },
    {
      action: "Upload-Dokumen",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Lihat",
      subject: "b-dokumen-inventarisasi",
    },

    {
      action: "Cetak-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
    {
      action: "Download-Dokumen-B",
      subject: "b-dokumen-inventarisasi",
    },
  ],
};
